export function getProfilePath(userRole?: string | null): string {
  return userRole === "staff" ? "/business/profile" : "/customer/profile"
}
